/// <amd-module name="CodeCoverage/CodeCoverageTab/Stores/BuildConfigSelectorStore" />
import { Store } from 'VSS/Reflux/Store';
import { CodeCoverageTabActionHub } from 'Actions/CodeCoverageTabActionHub';


export interface IBuildConfigItem {
    name: string;
    index: number;
}

export interface IBuildConfigSelectorState {
    buildConfigurationList: IBuildConfigItem[];
    selectedConfiguration: IBuildConfigItem;
}

export class BuildConfigSelectorStore extends Store {
	constructor(private changeEvent: string, private _actionsHub: CodeCoverageTabActionHub, private _defaultState: IBuildConfigSelectorState) {
		super(changeEvent);
        this._initialize();
    }
    
    public getState() {
        return this._state;
    }

    private _initialize(): void {
        this._state = this._defaultState;
        this._actionsHub.updateBuildConfigSelection.addListener(this._updateConfigSelectorState);
    }

    private _updateConfigSelectorState = (index: number)  => { 
        this._state = {
            buildConfigurationList: this._state.buildConfigurationList,
            selectedConfiguration: this._state.buildConfigurationList[index]
        }

        this.emitChanged();
    }

    private _state: IBuildConfigSelectorState;
}
